var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Container',{attrs:{"itemId":_vm.fileId},on:{"loaded":_vm.afterload}},[(_vm.url)?_c('iframe',{staticStyle:{"width":"100%","height":"calc(100vh - 5px)","border":"none"},attrs:{"src":_vm.url}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }